// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1WJYA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__21Vj5"};